<template>
  <qx-card-form title="事故登记">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    />
  </qx-card-form>
</template>

<script>
import {
  getEnumList,
} from 'api';
export default {
  data () {
    return {
      baseForm: {
        responsibilityAttributionOptions: [],
        form: [
          {
            label: '报案日期',
            value: 'q',
            type: 'date',
            default: '',
            attr: {
              time: '00:00:00',
            },
          },
          {
            label: '出险日期',
            value: 'w',
            type: 'date',
            default: '',
            attr: {
              time: '00:00:00',
            },
          },
          {
            label: '事故经过',
            value: 'e',
            type: 'input',
            attr: {
              type: 'textarea',
            },
          },
          {
            label: '出险原因',
            value: 'e',
            type: 'input',
            attr: {
              type: 'textarea',
            },
          },
          {
            label: '责任归属',
            value: 'responsibilityAttribution',
            type: 'select',
          },
          {
            label: '事故图片',
            value: 'a',
            type: 'img',
            accept: 'image/*',
            fileSize: 5120,
            default: [],
          },
          {
            label: '事故认定书',
            value: 's',
            type: 'img',
            accept: 'image/*',
            fileSize: 5120,
            default: [],
          },
        ],
        rules: {
        },
      },
    };
  },
  methods: {

    async getList () {
      const enumsData = await getEnumList({
        codeType: 'RESPONSIBILITY_ATTRIBUTION',
      });
      this.baseForm.responsibilityAttributionOptions = enumsData[0];
    },
    handleLabelTypeChange () {
      const balanceType = this.$refs.baseForm.getVal('balanceType');
      let isNotAuto = balanceType === '1';
      const tar = ['collection'];
      // 预付全款情况下隐藏收款期限
      this.baseForm.form.forEach((item) => {
        if (tar.indexOf(item.value) !== -1) {
          item.hide = isNotAuto;
        }
      });
    },
    async cacheData () {
      let res = await this.$refs.baseForm.getVal();
      res = {
        balanceType: res.balanceType,
        payWay: res.balanceType,
        ...this.otherFormData,
      };
      return res;
    },

    async sub () {
      let formData = await this.$refs.baseForm.sub();
      if (formData) {
        formData = {
          balanceType: formData.balanceType,
          payWay: formData.balanceType,
          ...this.otherFormData,
        };
      }
      return formData;
    },
    init (data = {}) {
      const res = {
        balanceType: data.payWay ? data.payWay : this.baseForm.balanceTypeOptions[0].value,
      };
      this.$refs.baseForm.setVal(res);
      this.setFormVal(this.otherFormData, data);
      this.handleLabelTypeChange();
    },
  },
};
</script>

<style scoped lang="scss">
</style>
